import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Configuration} from "../config/config";
import 'rxjs/add/operator/map';


@Injectable()
export class ModuleDetailsService {
  
  public jwtToken: string;
  constructor(private http: HttpClient) {
    const theUser:any = JSON.parse(localStorage.getItem('currentUser'));
    if (theUser) {
      this.jwtToken = theUser.token;
    }
  }

  refreshToken(){
    const theUser:any = JSON.parse(localStorage.getItem('currentUser'));
    if (theUser) {
      this.jwtToken = theUser.token;
    }
  }

  getCourseById(course_id, language_id){


    return this.http.get(Configuration.ServerWithApiUrl+'/courses/'+course_id + '/' + language_id)
      .map((res: any)=>res)
  }

  getCourseByIdWithLevelWiseProgress(obj){


    return this.http.post(Configuration.ServerWithApiUrl+'/course_with_level_progress/'+ obj.course_id, obj)
      .map((res: any)=>res)
  }

  getCourseDetailsByLevel(course_id, level, user_id, community_id, language_id){


    return this.http.get(Configuration.ServerWithApiUrl+'/course/'+course_id+'/'+level+'/'+user_id+'/'+community_id + '/' + language_id)
      .map((res: any)=>res)
  }

  getVideoById(id, lang_id, lang_name){


    return this.http.get(Configuration.ServerWithApiUrl+'/video/'+ id + '/' + lang_id +'/' + lang_name)
      .map((res: any)=>res)
  }

  getAssessmentById(id, lang_id){


    return this.http.get(Configuration.ServerWithApiUrl+'/assessment_details/'+ id + '/' + lang_id)
      .map((res: any)=>res)
  }

  updateLearnerTransaction(transaction_obj){


    return this.http.post(Configuration.ServerWithApiUrl+'/learner_transaction', transaction_obj)
      .map((res: any)=>res)
  }

  saveAssessmentForUser(obj){


    return this.http.post(Configuration.ServerWithApiUrl+'/assessment_evaluation', obj)
      .map((res: any)=>res)
  }
  getPlayedCertificateSteps(transaction_obj){


    return this.http.post(Configuration.ServerWithApiUrl+'/getPlayedCertificateSteps', transaction_obj)
      .map((res: any)=>res)
  }

  updatePlayedCertificateSteps(transaction_obj){


    return this.http.put(Configuration.ServerWithApiUrl+'/updatePlayedCertificateSteps', transaction_obj)
      .map((res: any)=>res)
  }

  getCertificateById(id, version, lang_id){

    return this.http.get(Configuration.ServerWithApiUrl + '/getCertificateByIdWithDeleted/'+id+'/'+ version + '/' + lang_id)
      .map((res: any)=>res)
  }

  getLatestCertificateById(id, lang_id){

    return this.http.get(Configuration.ServerWithApiUrl + '/getLatestCertificateById/'+id + '/' + lang_id)
      .map((res: any)=>res)
  }

  getCourseLevelsByCourseId(id){

    return this.http.get(Configuration.ServerWithApiUrl + '/courseLevels/'+id)
      .map((res: any)=>res)
  }

  getCourseGamesByLevels(id, level, language_id){

    return this.http.get(Configuration.ServerWithApiUrl + '/courseGamesByLevels/'+id+'/'+level + '/' + language_id )
      .map((res: any)=>res)
  }

  courseTransactionByLevelId(id, level, user_name){

    return this.http.get(Configuration.ServerWithApiUrl + '/courseTransactionByLevelId/'+id+'/'+level+'/'+user_name )
      .map((res: any)=>res)
  }

  getCertificateTransaction(course_id, certificate_id, user_name){

    return this.http.get(Configuration.ServerWithApiUrl + '/getCertificateTransaction/'+course_id+'/'+certificate_id+'/'+user_name )
      .map((res: any)=>res)
  }

  getCourseVideos(id, language_id){

    return this.http.get(Configuration.ServerWithApiUrl + '/getCourseVideos/'+id + '/' + language_id )
      .map((res: any)=>res)
  }

  getCourseResources(id, language_id){

    return this.http.get(Configuration.ServerWithApiUrl + '/getCourseResources/'+id + '/' + language_id )
      .map((res: any)=>res)
  }

  saveCourseTransaction(obj){

    return this.http.post(Configuration.ServerWithApiUrl + '/course_transaction', obj)
      .map((res: any)=>res)
  }

  getLicenseByCertificateId(certificate_id, community_id){

    return this.http.get(Configuration.ServerWithApiUrl + '/getLicenseByCertificateId/'+certificate_id+'/'+ community_id)
      .map((res: any)=>res)
  }

  getRespectiveInstruction(playedStepsData, stepData){

    for(let s=0; s<stepData.length; s++){
      var picked;
      const step = stepData[s];

      if(playedStepsData.played_steps && playedStepsData.played_steps.length > 0){

        if(step != undefined){
          picked = playedStepsData.played_steps.find(steps => steps.step_uid === step.step_id);
        }

        if(picked == undefined){
          let unMatcheSteps = [];
          let notMandatorySteps = [];
          let completedSteps = [];
          var curretnt = 0;
          for(let i=0; i< stepData.length; i++){
            let flag = false;
            for(let j=0; j< playedStepsData.played_steps.length; j++){
              if(stepData[i].step_id == playedStepsData.played_steps[j].step_uid){
                flag = true;
                curretnt = j;
                break;
              }
            }
            if(!flag){
              if(stepData[i].is_mandatory){
                unMatcheSteps.push(stepData[i]);
              }else {
                notMandatorySteps.push(stepData[i]);
              }
            }else {
              if(stepData[i].is_mandatory){
                completedSteps.push(playedStepsData.played_steps[curretnt]);
              }
            }
          }
          var flag = false;
          for(let i=0; i< completedSteps.length; i++){
            if(completedSteps[i].status == 'Inprogress'){
              flag = true;
            }
          }
          if(unMatcheSteps.length> 0){
            if(unMatcheSteps[0].step_id == step.step_id && flag == false){
              if(stepData[stepData.length-1].step_id== unMatcheSteps[0].step_id){
                return {choice : 'start', step_name : step.name};
              }else {
                return {choice : 'start', step_name : step.name};
              }
            }else {
              let flag = false;
              let val = 0;
              for(let i=0; i< notMandatorySteps.length; i++){
                if(notMandatorySteps[i].step_id == step.step_id){
                  flag = true;
                  val = i;
                }
              }
            }
          }
        }else {
          if(picked.status == 'Inprogress'){
            if(step.is_mandatory){
              return {choice : 'Inprogress', step_name : step.name};
            }
          }
        }
      }else {
        let flag = false;
        let val = 0;
        var mandatory = [];
        var notmandatory = [];

        for(let i=0; i< stepData.length; i++){
          if(stepData[i].is_mandatory == true){
            mandatory.push(stepData[i]);
          }else {
            notmandatory.push(stepData[i]);
          }
        }
        for(let i=0; i< notmandatory.length; i++){
          if(notmandatory[i].step_id == step.step_id){
            flag = true;
            val = i;
          }
        }
        if(flag){

        }else {
          if(mandatory[0].step_id == step.step_id){
            return {choice : 'start', step_name : step.name};
          }else {
          }
        }
      }
    }
  }

  getGameJsonData(gameName,flag,language, data){

    return this.http.post(Configuration.ServerWithApiUrl + '/readFile/'+ gameName +'/' + flag+'/'+language, data)
      .map((res: any)=>res)
  }

  isCertAssignedToComm(data){
    return this.http.post(Configuration.ServerWithApiUrl + '/isCertAssignedToComm', data)
      .map((res: any)=>res)
  }

  validateResourceUrl(data){
    return this.http.post(Configuration.ServerWithApiUrl + '/validateResourceUrl', data)
      .map((res: any)=>res)
  }

  getUserConfig(user_id){
    return this.http.get(Configuration.ServerWithApiUrl + '/getUserConfig/'+user_id)
      .map((res: any)=>res)
  }

  saveUserConfig(data){
    return this.http.post(Configuration.ServerWithApiUrl + '/saveUserConfig', data)
      .map((res: any)=>res)
  }

  getResourceDetailsById(id, lang){
    return this.http.get(Configuration.ServerWithApiUrl + '/resource/'+id+'/'+lang)
      .map((res: any)=>res)
  }

  getResourceConfiguration(id){
    return this.http.get(Configuration.ServerWithApiUrl + '/getResourceConfig/'+id)
      .map((res: any) => res)
  }

}



// WEBPACK FOOTER //
// ./src/app/Services/module-details.service.ts